module.exports = __webpack_public_path__ + "img/vertical_3_2_9016.8f6d1f17.png";